import React from 'react';
import { Box, Icon, Text } from '@zillow/constellation-10';
import {
  IconRateVeryUnhappyFilled,
  IconWrenchOutline,
} from '@zillow/constellation-icons';

const StyledIcon = ({
  children,
  ...props
}: React.ComponentProps<typeof Icon>) => {
  return (
    <Icon
      css={{
        display: 'block',
        height: '8rem',
        width: '8rem',
        margin: '0 auto',
        color: '#ff8c8f',
      }}
      {...props}
    >
      {children}
    </Icon>
  );
};

const StyledBrokenIcon = () => (
  <StyledIcon>
    <IconRateVeryUnhappyFilled />
  </StyledIcon>
);
const StyledWrenchIcon = () => (
  <StyledIcon>
    <IconWrenchOutline />
  </StyledIcon>
);

const Container = ({
  children,
  ...props
}: React.ComponentProps<typeof Box>) => (
  <Box css={{ display: 'flex', flexDirection: 'column' }} {...props}>
    {children}
  </Box>
);

const Contents = ({ children, ...props }: React.ComponentProps<typeof Box>) => (
  <Box asChild css={{ padding: '4.5rem 1.25rem' }} {...props}>
    <main>{children}</main>
  </Box>
);

const MainMessage = ({ children }: { children: React.ReactNode }) => (
  <Text
    css={{
      display: 'block',
      textAlign: 'center',
      margin: '40px 0 0 !important',
      color: '#2a2a33',
      fontSize: '22px !important',
      lineHeight: '33px !important',
    }}
  >
    {children}
  </Text>
);

const SubMessage = ({ children }: { children: React.ReactNode }) => (
  <Text
    css={{
      display: 'block',
      textAlign: 'center',
      margin: '24px 0 0 !important',
      fontSize: '16px !important',
      lineHeight: '22px !important',
    }}
  >
    {children}
  </Text>
);

export enum ErrorIcon {
  Broken = 'broken',
  Wrench = 'wrench',
}

type Props = {
  mainMessage?: string | React.ReactNode;
  subMessage?: string | React.ReactNode;
  errorIcon?: ErrorIcon;
};

function ErrorMessage(props: Props) {
  const {
    mainMessage = 'Uh oh! Looks like something went wrong.',
    subMessage = 'Try to refresh the page or please try again later',
    errorIcon = ErrorIcon.Broken,
  } = props;

  return (
    <Container>
      <Contents>
        {errorIcon === ErrorIcon.Wrench ? (
          <StyledWrenchIcon />
        ) : (
          <StyledBrokenIcon />
        )}
        <MainMessage>{mainMessage}</MainMessage>
        <SubMessage>{subMessage}</SubMessage>
      </Contents>
    </Container>
  );
}

export default ErrorMessage;
